import { styled } from '@fluentui/react';
import { FormItemBase } from './FormItem.base';
import { getStyles } from './FormItem.styles';
import { IFormItemProps, IFormItemStyleProps, IFormItemStyles } from './FormItem.types';

// Use Fabric Base guidelines since this might be contributed back to Fabric.
export const FormItem = styled<IFormItemProps, IFormItemStyleProps, IFormItemStyles>(FormItemBase, getStyles, undefined, {
  scope: 'FormItem',
});
